import { mockContact, type Agency } from "types/contact";
import { mockProperty, type TenantPortalProperty } from "types/property";
import { mockTenancy, type TenantPortalTenancy } from "types/tenancy";
import { apiClient } from "utils/api-client/index";
import { createModel } from "utils/models";

export type OverviewData = {
  tenancy: TenantPortalTenancy;
  property: TenantPortalProperty;
  agency: Agency;
};

export const tenancyOverviewModel = createModel("tenancyOverview", {
  queries: {
    read: (propertyTenancyId?: string) => ({
      queryKey: ["read", propertyTenancyId],
      queryFn: (): Promise<OverviewData | undefined> => {
        return Promise.all([
          apiClient.get<TenantPortalTenancy>(
            `/tenant-portal/property-tenancies/${propertyTenancyId}/tenancy`,
          ),
          apiClient.get<TenantPortalProperty>(
            `/tenant-portal/property-tenancies/${propertyTenancyId}/property`,
          ),
          apiClient.get<Agency>(
            `/tenant-portal/property-tenancies/${propertyTenancyId}/agency`,
          ),
        ]).then(([tenancy, property, agency]) => {
          return {
            tenancy: tenancy,
            property: property,
            agency: agency,
          };
        });
      },
      enabled: !!propertyTenancyId,
      keepPreviousData: true,
    }),
  },
});

export const mockTenancyOverviewResponse = () => {
  return {
    tenancy: mockTenancy(),
    property: mockProperty(),
    agency: mockContact(),
  };
};
